export default __webpack_public_path__ + "static/media/Jan_Van_Huysum_Still_life_with_flowers_and_fruit_50_x_70_cm.d8abace7.jpg";